export default "__VITE_ASSET__DSWikll6__"